<template>
    <div class="app-inner fixed fixed-head-3">
        <!--/-->
        <div class="app-head">
            <common-header></common-header>
            <common-nav></common-nav>
            <el-row class="c_nav_menu_wrapper c_subnav">
                <el-menu :default-active="getActiveIndex()" class="c_nav_menu" mode="horizontal" router>
                    <el-menu-item index="/purchase/canmou">采购参谋</el-menu-item>
                    <!--<el-menu-item index="/purchase/plan">采购计划</el-menu-item>-->
                </el-menu>
            </el-row>
        </div>

        <!--/-->
        <div class="app-body">
            <my-bscroll>
                <keep-alive>
                    <router-view></router-view>
                </keep-alive>
            </my-bscroll>
        </div>
    </div>
</template>

<script>
export default {
    data :function() {
        return {
            getActiveIndex:function(){
                let path = this.$route.path;
                if(path.startsWith('/purchase/plan')) return '/purchase/plan';
                return path;
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/purchase/_layout.vue